export const TODAY_DEFAULT_VALUE = '_today'
